module.exports = __webpack_public_path__ + "img/v4_fee1.0c42e478.png";